import { getRegistrationInfo, saveRegistrationInfo } from "../api/registrationInfo";
import { getApplicationSettings, getInternationalCountries, getInternationalStates, getInternationalPreferredCountries } from "../api/applicationSettings";
import { quickCheckout } from "../api/checkout";
import { removeDefaultSessions } from "../api/registration";
import { getMembership } from "../api/membership";
import * as membershipActions from "../actions/membershipActions";
import * as registrationActions from "../actions/registrationActions";
import * as accountActions from "../actions/accountActions";
import { connect } from "react-redux";
import * as config from "../config";
import Page from "./Page";
import Box from "./Box";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import ProofOfStudiesUpload from "./ProofOfStudiesUpload";
import LoadingButton from "./LoadingButton";
import { toast } from "react-toastify";
import LoadingContent from "./LoadingContent";
import * as account from "../api/account";
import { fallConferenceSessionsUrl } from "../config";
import { nationalConferenceSessionsUrl } from "../config";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "postal-codes-js";
import libphonenumber from "google-libphonenumber";

// todo: move this to configuration
const strings = {
  conferenceTermsOfService: "https://www.aanp.org/aanp-conference-terms-of-service-and-release-of-liability",
  aanpTermsOfUse: "https://www.aanp.org/aanp-terms-of-use",
  aanpPrivacyPolicy: "https://www.aanp.org/aanp-privacy-policy",
};

const validationStrings = {
  error: "error",
  required: "This field is required.",
};

// this is used as a KVPair to reference a stateKey by . notation instead of strings
const input = {
  npi: "npi",
  workingOrVolunteeringAsNP: "workingOrVolunteeringAsNP",
  howDidYouHear: "howDidYouHear",
  addressType: "addressType",
  country: "country",
  county: "county",
  street1: "street1",
  city: "city",
  zip: "zip",
  state: "state",
  cellPhone: "cellPhone",
  homePhone: "homePhone",
  businessPhone: "businessPhone",
  ext: "ext",
  emergencyContactFirstName: "emergencyContactFirstName",
  emergencyContactLastName: "emergencyContactLastName",
  emergencyContactPhoneNumber: "emergencyContactPhoneNumber",
  emergencyContactEmail: "emergencyContactEmail",
  ackCovidSafety: "ackCovidSafety",
  usNp: "usNp",
  primaryPracticeState: "primaryPracticeState",
  npCompanyName: "npCompanyName",
};

const errorText = { color: "red" }

class DefaultConferenceQuestions extends PureComponent {
  
  static propTypes = {
    me: PropTypes.object.isRequired,
    storeRegistrationMembershipType: PropTypes.func.isRequired,
    storeRegistrationMethod: PropTypes.func.isRequired,
    registrationMembershipType: PropTypes.string,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {

    console.log("constructor");

    super(props);

    this.state = {      
      registrationInfo: {        
        memberType: "",
        registeringAs: "",
      },
      applicationSettings: [{}],
      internationalCountriesWithStates: [],
      internationalCountries: [{}],
      internationalPreferredCountries: [{}],
      internationalStates: [{}],
      internationalCountryCodes: [],
      isLoadingQuickCheckout: false,
      isLoadingCheckout: false,
      validation: {},
      loadingPrerequisites: true,
      loading: true,
      studentApprovalUploaded: false,
      ackCovidSafety: false,
      showInternationalRegionTerritory: false,
      showState: true,
      usNp: "",
      primaryPracticeState: "",
      npCompanyName: "",
      companyName: "",
  };
    
    this.ref_emergencyContactPhoneNumber = React.createRef();
    this.ref_contactMobilePhoneNumber = React.createRef();
    this.ref_contactHomePhoneNumber = React.createRef();
    this.ref_contactOfficePhoneNumber = React.createRef();
    this.ref_contactCountry = React.createRef();
    this.ref_contactPostalCode = React.createRef();
  }

  componentDidMount = () => {
    
    console.log("componentDidMount");

    this._getApplicationSettings();
    this._getInternationalCountries(); 
    this._getInternationalPreferredCountries();
    this._getRegistrationInfo();   
  };

  _getApplicationSettings = () => { 

    console.log("_getApplicationSettings");

    this.setState({ loadingPrerequisites: true });
    
    getApplicationSettings().then((response) => {        
      this.setState({ applicationSettings: JSON.parse(response), loadingPrerequisites: false });
    })    
  }

  _getInternationalStates = (countryName) =>
  {   
    console.log("_getInternationalStates");

    getInternationalStates(countryName).then((response) => {
      this.setState({ internationalStates: response });      
    })
  }

  _getInternationalCountries = () => { 
    console.log("_getInternationalCountries");

    this.setState({ loadingPrerequisites: true });

    getInternationalCountries().then((response) => {      
      this.setState({ internationalCountryCodes: response.map(({ iso2 }) => iso2) });
      this.setState({ internationalCountries: response, loadingPrerequisites: false });
    })
  }

  _getInternationalPreferredCountries = () => {

    console.log("_getInternationalPreferredCountries");

    this.setState({ loadingPrerequisites: true });

    getInternationalPreferredCountries().then((response) => {            
      this.setState({ internationalPreferredCountries: response.map(({ iso2 }) => iso2) });
      this.setState({ internationalCountries: response, loadingPrerequisites: false });
    })
  }

  _getRegistrationInfo = () => {

    console.log("_getRegistrationInfo");

    this.setState({ loading: true });

    getRegistrationInfo().then((response) => { 

      const states = ["United States", "Canada", "Australia"];
      this.setState({ internationalCountriesWithStates: states });

      console.log("this.props.registrationMembershipType: " + this.props.registrationMembershipType);

      const registeringAs = this.props.registrationMembershipType;

      if (registeringAs === "Retired Member") {
        response.isRetired = true;
      } else if (registeringAs === "Post Master's Student") {
        response.isPostGrad = true;
      }

      if (registeringAs === "Career Starter Member") {
        response.isGraduated = true;
      } else if (localStorage.getItem(config.storageKeys.isNp) === "true") {
        response.isNp = true;
      }

      this.setState({ registrationInfo: response });

      console.log("API Address Response");
      console.log("PreferredMailingAddress: " + response.preferredMailingAddress);
      console.log("AddressType: " + response.addressType);
      console.log("Street1: " + response.street1);
      console.log("Street2: " + response.street2);
      console.log("City: " + response.city);
      console.log("State: " + response.state);
      console.log("Zip: " + response.zip);
      console.log("County: " + response.county);
      console.log("Country: " + response.country);
      console.log("emergencyContactPhoneNumber: " + response.emergencyContactPhoneNumber);
      console.log("Working/Volunteering: " + response.workingOrVolunteeringAsNP);

      // rules defined by JS: 10-06-2023
      if(response.preferredMailingAddress === "Business Address") {
        console.log("response.preferredMailingAddress is Business Address. Converting to Work Address.");
        response.preferredMailingAddress = "Work Address";
      }

      //SS - 2025-11-14 - changes to add a new Company Name field to the form
      if (response.preferredMailingAddress === "Work Address" && response.companyName !== null && response.companyName !== "") {
        response.npCompanyName = response.companyName;
      } 

      if(response.preferredMailingAddress === "Work Address") {
        this.setState({npCompanyName: response.companyName || ""});
        this.setState({companyName: response.companyName || ""});
      }

      console.log("Organization Name: "+ response.npCompanyName);
      //-------------------------------------------------------------------------------------------------------------------


      if (response.preferredMailingAddress === "" || (response.preferredMailingAddress !== "Home Address" || response.preferredMailingAddress !== "Work Address") === false) {
        console.log("Unexpected response.preferredMailingAddress. Clearing address information.");
        response.preferredMailingAddress = "Home Address";
        response.addressType = "Home Address";
        response.street1 = "";
        response.street2 = "";
        response.city = "";
        response.zip = "";
        response.county = "";
        response.country = "United States";
      }

      // if this is a non-member with no address in Aptify, default them to a U.S. address
      if(response.country === null || response.country === "")
      {
        console.log("Address country is NULL (likely non-member), setting country to United States");
        this.setState({ showInternationalRegionTerritory: false });
        this.setState({ showState: true});
        response.country = "United States";
      }

      if(response.cellPhone !== null && response.cellPhone !== "" && response.cellPhone.replace(/[^0-9]/g,"").length === 10) {        
        if(response.country.toUpperCase() === "UNITED STATES" || response.country.toUpperCase() === "CANADA") {
          response.cellPhone = "+1" + response.cellPhone;
        }
      }
      if(response.homePhone !== null && response.homePhone !== "" && response.homePhone.replace(/[^0-9]/g,"").length === 10) {        
        if(response.country.toUpperCase() === "UNITED STATES" || response.country.toUpperCase() === "CANADA"){
          response.homePhone = "+1" + response.homePhone;
        }
      }
      if(response.businessPhone !== null && response.businessPhone !== "" && response.businessPhone.replace(/[^0-9]/g,"").length === 10) {        
        if(response.country.toUpperCase() === "UNITED STATES" || response.country.toUpperCase() === "CANADA") {
          response.businessPhone = "+1" + response.businessPhone;
        }
      }
      console.log("this.state.internationalCountriesWithStates.includes(response.country): " + this.state.internationalCountriesWithStates.includes(response.country));
      console.log("this.state.internationalCountriesWithStates.length: " + this.state.internationalCountriesWithStates.length);

      if(this.state.internationalCountriesWithStates.length === 0) {
        console.log("this.state.internationalCountriesWithStates has not been initialized yet!");
      }

      if(this.state.internationalCountriesWithStates.includes(response.country))
      {
        console.log("set state to show state, not territory");
        this.setState({ showInternationalRegionTerritory: false });
        this.setState({ showState: true});
      }
      else
      {
        console.log("set state to show territory, not state");
        this.setState({ showInternationalRegionTerritory: true });
        this.setState({ showState: false});
      }

      this._getInternationalStates(response.country);
      
      const target = {
        name: "country",
        value: response.country,
      };

      const event = {        
        target,
      }

      //const usNp = (!response.primaryPracticeState || response.primaryPracticeState.length === 0) ? "" : "Yes";
      const usNp = (!response.workingOrVolunteeringAsNP || response.workingOrVolunteeringAsNP !== "Yes" || 
          !response.primaryPracticeState || response.primaryPracticeState.length === 0) ? "" : "Yes";

      this._handleChange(event)

      this.setState((prevState) => ({
        ...prevState,
        registrationInfo: {
          ...prevState.registrationInfo,
          registeringAs: this._getMembershipType(),
          usNp: usNp,
        }, 
        loading: false,
      }));
    });
  };

  _onPhoneNumberChange = (value, country, event, formattedValue) => {  
    // target will be null when changing country via click
    try {      
        let { registrationInfo } = this.state;
        let controlName = event.target.name;
        console.log("_onPhoneNumberChange: " + controlName + ", formattedValue: " + formattedValue); 
        registrationInfo[controlName] = formattedValue;
    } catch (error) {
      // intentionally ignored. event.target is likely NULL     
    }
  }

  _handleChange = (e) => {   

    let { registrationInfo } = this.state;
    const validation = { ...this.state.validation };

    const target = e.target;
    const name = target.name;
    let value = target.value;    

    console.log("_handleChange target: " + target + " name: " + name + " value: " + value);

    delete validation[name];

    //SS - 2025-11-15
    if (name === "npCompanyName" || name === "companyName") {
      console.log("Updating both fields to:", value);
      //update both fields with the same value
      this.setState ({
        npCompanyName: value,
        companyName: value
      });

      console.log("npCompanyName: " + this.state.npCompanyName);
      console.log("CompanyName: " + this.state.companyName);
    }

    if(name === "country") {
      
      registrationInfo.country = target.value;     

      if(this.state.internationalCountriesWithStates.includes(target.value)) {     
        
        this.setState({ showInternationalRegionTerritory: false});
        this.setState({ showState: true});

        this._getInternationalStates(target.value);

      } else {

        this.setState({ showInternationalRegionTerritory: true});
        this.setState({ showState: false});        
      }      
    }

    if (name === "ackCovidSafety") {
      this.setState({ ackCovidSafety: e.target.checked });             
    }

    if (name === "ext") {
      
      let countryDataContactOfficePhoneNumber = this.ref_contactOfficePhoneNumber.current.getCountryData();         
      let contactOfficePhoneNumber = this.ref_contactOfficePhoneNumber.current.numberInputRef.value.replace(/\D/g, "").trim()   
      let contactOfficePhoneNumberWithoutDialCode = contactOfficePhoneNumber.replace(countryDataContactOfficePhoneNumber.dialCode, "").trim();
      
      if (contactOfficePhoneNumberWithoutDialCode === "") {        
        validation[input.contactOfficePhoneNumber] = { state: validationStrings.error, helpBlock: validationStrings.required };
        validation[input.ext] = { state: validationStrings.error, helpBlock: validationStrings.required };
      }
    }

    if (typeof e.target.checked !== "undefined" && e.target.type === "checkbox")
    {
      value = target.checked;
    }

    if (name === "isNp") 
    {
      if (value) 
      {
        registrationInfo.isGraduated = false;
      }
    } 
    else if (name === "isGraduated") 
    {
      if (value) 
      {
        registrationInfo.isNp = false;
      }
    } 
    else if (name === "workingOrVolunteeringAsNP") 
    {
      registrationInfo.isRetired = false;
      registrationInfo.isPostGrad = false;
      registrationInfo.isNp = false;
      registrationInfo.isGraduated = false;
      registrationInfo.npCompanyName = this.state.npCompanyName;
      registrationInfo.primaryPracticeState = "";
      registrationInfo.usNp = "";
      //console.log("WORK/VOL Value: " + registrationInfo.npCompanyName);
      console.log("WORK/VOL Value: " + this.state.npCompanyName);
    }

    if (name === "usNp") {
      if (value === "No") {
        registrationInfo.primaryPracticeState = "";
      }
    }

    if (name === "isPostGrad") {
      registrationInfo.isRetired = false;
    } else if (name === "isRetired") {
      registrationInfo.isPostGrad = false;
    } 

    registrationInfo[name] = value;

    registrationInfo.registeringAs = this._getMembershipType();

    this.setState((prevState) => ({ ...prevState, validation, registrationInfo: { ...prevState.registrationInfo } }));
  };

  _getMembershipType = () => {
    console.log("_getMembershipType");
    let { registrationInfo } = this.state;

    let registeringAs = "";

    if (this.props.me.person.isMember) {
      registeringAs = this.props.me.person.memberType;
    }

    if (registrationInfo.isRetired) {
      registeringAs = "Retired Member";
    } else if (registrationInfo.isPostGrad) {
      registeringAs = "Post Master's Student";
    } else if (registrationInfo.isNp && !(registeringAs === "Student Member" || registeringAs === "International Student Member")) {
      registeringAs = "NP Member";     
    } else if (registrationInfo.isGraduated) {
      registeringAs = "Career Starter Member";
    } else if ((registeringAs === "Student Member" || registeringAs === "International Student Member") && !(registrationInfo.isNp || registrationInfo.isGraduated)) {      
      registeringAs = "NP Member";      
    } else if (registeringAs === "Post Master's Student Member" && !registrationInfo.isPostGrad) {
      registeringAs = "NP Member";
    }

    return registeringAs;
  };

  _saveRegistrationInfo = (e) => {
    console.log("_saveRegistrationInfo");
    if (e) {
      e.preventDefault();
    }

    if (this._validForm()) {

      console.log("this._validForm() === true");

      const nextPage = e.target.value;

      let { registrationInfo } = this.state;

      registrationInfo.companyName = this.state.companyName;
      registrationInfo.npCompanyName = this.state.npCompanyName;

      // clean up for Aptify for Home number
      if (this.ref_contactHomePhoneNumber.current.numberInputRef.value.trim() === "" || this.ref_contactHomePhoneNumber.current.numberInputRef.value.trim() === "+") {
        registrationInfo.homePhone = "+" + this.ref_contactHomePhoneNumber.current.getCountryData().dialCode;        
      }
      else {
        registrationInfo.homePhone = this.ref_contactHomePhoneNumber.current.numberInputRef.value.trim();        
      }

      // clean up for Aptify for Mobile number
      if (this.ref_contactMobilePhoneNumber.current.numberInputRef.value.trim() === "" || this.ref_contactMobilePhoneNumber.current.numberInputRef.value.trim() === "+") {
        registrationInfo.cellPhone = "+" + this.ref_contactMobilePhoneNumber.current.getCountryData().dialCode;        
      }
      else {
        registrationInfo.cellPhone = this.ref_contactMobilePhoneNumber.current.numberInputRef.value.trim();        
      }

      // clean up for Aptify for Office number
      if (this.ref_contactOfficePhoneNumber.current.numberInputRef.value.trim() === "" || this.ref_contactOfficePhoneNumber.current.numberInputRef.value.trim() === "+") {
        registrationInfo.businessPhone = "+" + this.ref_contactOfficePhoneNumber.current.getCountryData().dialCode;        
      }
      else {
        registrationInfo.businessPhone = this.ref_contactOfficePhoneNumber.current.numberInputRef.value.trim();        
      }

      console.log("writing registrationInfo.homePhone: " + registrationInfo.homePhone);
      console.log("writing registrationInfo.cellPhone: " + registrationInfo.cellPhone);
      console.log("writing registrationInfo.businessPhone: " + registrationInfo.businessPhone);

      if (nextPage === "checkout") {
        this.setState({
          isLoadingQuickCheckout: true,
        });
      } else {
        this.setState({
          isLoadingCheckout: true,
        });
      }

      this.props.storeRegistrationMembershipType(
        registrationInfo.registeringAs
      );

      saveRegistrationInfo(registrationInfo).then((response) => {
        this.props.storeRegistrationMethod("");

        localStorage.setItem(config.storageKeys.isNp, registrationInfo.isNp);

        account.me().then((me) => {
          if (this.props.me.person.isMember) {
            const membershipType = this.props.me.availableMembershipTypes.find(
              (m) => m.useForJoinCampaign === true
            );
            if (
              registrationInfo.registeringAs === "Associate Member" &&
              me.person.memberType === "Associate Member" &&
              me.person.isMember
            ) {
              this.props.storeRegistrationMembershipType(
                registrationInfo.registeringAs
              );
            } else if (false && membershipType) {
              this.props.storeRegistrationMembershipType(
                membershipType.membershipTypeName
              );
              if (registrationInfo.registeringAs === "Associate Member") {
                registrationInfo.registeringAs =
                  membershipType.membershipTypeName;
              }
            } else {
              this.props.storeRegistrationMembershipType(
                registrationInfo.registeringAs
              );
            }
          }

          if (nextPage === "checkout") {
            this.props.storeRegistrationMethod("quick");
            if (!me.isRegistered) {
              quickCheckout().then((response) => {
                this.props.history.push("/checkout");
              });
            } else {
              this.props.history.push("/checkout");
            }
          } else {
            if (!me.isRegistered) {
              removeDefaultSessions().then((response) => {
                const showJoinRenew =
                  me.membershipStatus !== 1 &&
                  me.membershipStatus !== 2 &&
                  me.availableMembershipTypes.filter((m) => !m.disabledForUser)
                    .length > 0;

                if (showJoinRenew) {
                  if (!registrationInfo.registeringAs) {                    
                    registrationInfo.registeringAs = "NP Member";                    
                  }

                  getMembership(
                    registrationInfo.registeringAs,
                    localStorage.getItem(config.storageKeys.promoCode)
                  ).then((response) => {
                    if (
                      response.hasEventDiscount ||
                      response.savings <= response.savingsLimit
                    ) {
                      this.props.history.push("/" + nextPage);
                    } else {
                      this.props.history.push("/membership");
                    }
                  });
                } else {
                  this.props.history.push("/" + nextPage);
                }
              });
            } else {
              this.props.history.push("/" + nextPage);
            }
          }
        });
      });
    } else {
      console.log("this._validForm() === false");
      toast.error("Please review and complete the registration information.", {autoClose: 10000});
    }
  };

  _isValidPhone = (phoneNumber, iso2) => {
    console.log("_isValidPhone. phoneNumber: " + phoneNumber + " iso2: " + iso2);
    const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
    try {
      let numberProto = phoneUtil.parse(phoneNumber, iso2);
      return phoneUtil.isValidNumber(numberProto);
    } catch (e) {
      console.log("Error in _isValidPhone: " + e.toString());
    }
  };

  _isValidEmail(email) {
    console.log("_isValidEmail");
    return /\S+@\S+\.\S+/.test(email);
  };
  
  _isValidPostalCode(iso2, value) {
    console.log("_isValidPostalCode iso2: " + iso2 + " value: " + value);
    const postalCodes = require('postal-codes-js');
    console.log(postalCodes.validate(iso2, value));
    return postalCodes.validate(iso2, value);
  }

  _validForm = () => {

    console.log("_validForm");

    const validation = {};

    let { event } = this.props.me;

    if (event.conferenceType !== "Virtual") {
      if(this.state.applicationSettings["showCovidAttestation"] === true && !this.state.ackCovidSafety) { 
        console.log("ackCovidSafety failed validation");
        validation[input.ackCovidSafety] = { state: validationStrings.error, helpBlock: validationStrings.required };   
      }
    } 

    let { registrationInfo } = this.state;
    console.log("valid reg info", registrationInfo);

    Object.keys(registrationInfo).forEach((stateKey) => {
      
      console.log("stateKey: " + stateKey);

      if (input[stateKey]) {

        if(config.showEmergencyContactSection === true) {

          if(stateKey === input.emergencyContactFirstName || stateKey === input.emergencyContactLastName) {   
            if(registrationInfo[stateKey].trim() === "") {
              console.log(stateKey + " failed validation (1)");
                validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error }
            }
          }

          if(stateKey === input.emergencyContactPhoneNumber) {           

            console.log("Evaluating contact phone number: " + stateKey);

            // emergency contact mobile phone
            let countryDataEmergencyContactMobilePhoneNumber = this.ref_emergencyContactPhoneNumber.current.getCountryData();         
            let emergencyContactMobilePhoneNumber = this.ref_emergencyContactPhoneNumber.current.numberInputRef.value.replace(/\D/g, "").trim()          
            let emergencyContactMobilePhoneNumberWithoutDialCode = emergencyContactMobilePhoneNumber.replace(countryDataEmergencyContactMobilePhoneNumber.dialCode, "").trim(); 

            if(stateKey === input.emergencyContactPhoneNumber && emergencyContactMobilePhoneNumberWithoutDialCode !== "") {            
              
              console.log("countryDataEmergencyContactMobilePhoneNumber.countryCode.toUpperCase(): " + countryDataEmergencyContactMobilePhoneNumber.countryCode.toUpperCase());

              if (this._isValidPhone(this.ref_emergencyContactPhoneNumber.current.numberInputRef.value, countryDataEmergencyContactMobilePhoneNumber.countryCode.toUpperCase()))
              {
                console.log("Emergency number is valid. Number: " + 
                  this.ref_emergencyContactPhoneNumber.current.numberInputRef.value + " iso2: " + countryDataEmergencyContactMobilePhoneNumber.countryCode.toUpperCase());
              }
              else {
                console.log("Emergency number is invalid.");
                validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error };
                toast.error("Emergency number " + this.ref_emergencyContactPhoneNumber.current.numberInputRef.value + " is not valid for country " + countryDataEmergencyContactMobilePhoneNumber.name + ".", { autoClose: 10000 });
              }
            }  
            
            if (emergencyContactMobilePhoneNumberWithoutDialCode === "") {
              console.log(stateKey + " failed validation. Phone number must be provided.");
              validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.required };
              toast.error("Blank is not a valid emergency contact phone number.", {autoClose: 10000});
            }
          }
          
          if(stateKey === input.emergencyContactEmail ) {                    
            if(!this._isValidEmail(registrationInfo[stateKey])) {    
              console.log(stateKey + " failed validation");                        
              validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error };
              toast.error((registrationInfo[stateKey] === "" ? "Blank" : registrationInfo[stateKey]) + " is not a valid e-mail address.", {autoClose: 10000});
            }
          }
        }

        if (stateKey === input.cellPhone || stateKey === input.homePhone || stateKey === input.businessPhone) {        
          console.log("Evaluating contact phone number: " + stateKey);
          
          // contact mobile phone
          let countryDataContactMobilePhoneNumber = this.ref_contactMobilePhoneNumber.current.getCountryData(); 
          let contactMobilePhoneNumber = this.ref_contactMobilePhoneNumber.current.numberInputRef.value.replace(/\D/g, "").trim()          
          let contactMobilePhoneNumberWithoutDialCode = contactMobilePhoneNumber.replace(countryDataContactMobilePhoneNumber.dialCode, "").trim();

          if(stateKey === input.cellPhone && contactMobilePhoneNumberWithoutDialCode !== "") {            
            if (this._isValidPhone(this.ref_contactMobilePhoneNumber.current.numberInputRef.value, countryDataContactMobilePhoneNumber.countryCode.toUpperCase()))
            {
              console.log("Mobile number is valid. Number: " + 
                this.ref_contactMobilePhoneNumber.current.numberInputRef.value + " iso2: " + countryDataContactMobilePhoneNumber.countryCode.toUpperCase());
            }
            else {
              console.log("Mobile number is invalid.");
              validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error };
              toast.error("Mobile number " + this.ref_contactMobilePhoneNumber.current.numberInputRef.value + " is not valid for country " + countryDataContactMobilePhoneNumber.name + ".", { autoClose: 10000 });
            }
          }          

          // contact home phone
          let countryDataContactHomePhoneNumber = this.ref_contactHomePhoneNumber.current.getCountryData();         
          let contactHomePhoneNumber = this.ref_contactHomePhoneNumber.current.numberInputRef.value.replace(/\D/g, "").trim()          
          let contactHomePhoneNumberWithoutDialCode = contactHomePhoneNumber.replace(countryDataContactHomePhoneNumber.dialCode, "").trim();  

          if(stateKey === input.homePhone && contactHomePhoneNumberWithoutDialCode !== "") {            
            if (this._isValidPhone(this.ref_contactHomePhoneNumber.current.numberInputRef.value, countryDataContactHomePhoneNumber.countryCode.toUpperCase()))
            {
              console.log("Home number is valid. Number: " + 
                this.ref_contactHomePhoneNumber.current.numberInputRef.value + " iso2: " + countryDataContactHomePhoneNumber.countryCode.toUpperCase());
            }
            else {
              console.log("Home number is invalid.");
              validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error };
              toast.error("Home number " + this.ref_contactHomePhoneNumber.current.numberInputRef.value + " is not valid for country " + countryDataContactHomePhoneNumber.name + ".", { autoClose: 10000 });
            }
          } 

          // contact office phone
          let countryDataContactOfficePhoneNumber = this.ref_contactOfficePhoneNumber.current.getCountryData();         
          let contactOfficePhoneNumber = this.ref_contactOfficePhoneNumber.current.numberInputRef.value.replace(/\D/g, "").trim()   
          let contactOfficePhoneNumberWithoutDialCode = contactOfficePhoneNumber.replace(countryDataContactOfficePhoneNumber.dialCode, "").trim();

          if(stateKey === input.businessPhone && contactOfficePhoneNumberWithoutDialCode !== "") {            
            if (this._isValidPhone(this.ref_contactOfficePhoneNumber.current.numberInputRef.value, countryDataContactOfficePhoneNumber.countryCode.toUpperCase()))
            {
              console.log("Office number is valid. Number: " + 
                this.ref_contactOfficePhoneNumber.current.numberInputRef.value + " iso2: " + countryDataContactOfficePhoneNumber.countryCode.toUpperCase());
            }
            else {
              console.log("Office number is invalid.");
              validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error };
              toast.error("Office number " + this.ref_contactOfficePhoneNumber.current.numberInputRef.value + " is not valid for country " + countryDataContactOfficePhoneNumber.name + ".", { autoClose: 10000 });
            }
          } 

          if (contactMobilePhoneNumberWithoutDialCode === "" && contactHomePhoneNumberWithoutDialCode === "" && contactOfficePhoneNumberWithoutDialCode === "") {
            console.log(stateKey + " failed validation. One phone number must be provided.");
            validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.required };
          }
        }

        if (stateKey === input.ext && registrationInfo[stateKey].length > 0) {

          let countryDataContactOfficePhoneNumber = this.ref_contactOfficePhoneNumber.current.getCountryData();         
          let contactOfficePhoneNumber = this.ref_contactOfficePhoneNumber.current.numberInputRef.value.replace(/\D/g, "").trim()   
          let contactOfficePhoneNumberWithoutDialCode = contactOfficePhoneNumber.replace(countryDataContactOfficePhoneNumber.dialCode, "").trim();
          
          if (contactOfficePhoneNumberWithoutDialCode === "") {
            console.log(stateKey + " failed validation. Office number must be provided if extension is entered.");          
            validation[input.contactOfficePhoneNumber] = { state: validationStrings.error, helpBlock: validationStrings.required };
            validation[input.ext] = { state: validationStrings.error, helpBlock: validationStrings.required };
          }
        }

        if (stateKey === input.npi) {            
          if(!registrationInfo.attest) {
            if((registrationInfo.npi === null || registrationInfo.npi === "") === true){
              console.log(stateKey + " failed validation");
              validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.required };
            } else if (registrationInfo.npi !== null && registrationInfo.npi.length < 10) {
              console.log(stateKey + " failed validation");
              validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.required };
            }
          }
        }

        if (stateKey === input.howDidYouHear && !registrationInfo.howDidYouHear) {
          console.log(stateKey + " failed validation");
          validation[input.howDidYouHear] = { state: validationStrings.error, helpBlock: validationStrings.required };
        }

        if (stateKey === input.workingOrVolunteeringAsNP && !registrationInfo.workingOrVolunteeringAsNP) {
          console.log(stateKey + " failed validation");
          validation[input.workingOrVolunteeringAsNP] = { state: validationStrings.error, helpBlock: validationStrings.required };
        }

        if (stateKey === input.usNp) {
          if(registrationInfo.workingOrVolunteeringAsNP === "Yes" && registrationInfo.usNp === "") {
            console.log(stateKey + " failed validation");
            validation[input.usNp] = { state: validationStrings.error, helpBlock: validationStrings.required };
          } 
        }

        if (stateKey === input.primaryPracticeState) {
          if(registrationInfo.workingOrVolunteeringAsNP === "Yes" && registrationInfo.usNp === "Yes" && !registrationInfo.primaryPracticeState) {
            console.log(stateKey + " failed validation");
            validation[input.primaryPracticeState] = { state: validationStrings.error, helpBlock: validationStrings.required };
          } 
        }

        //SS - 2025-11-15 - validation for the new company name field
        if (stateKey === input.npCompanyName) {
          if(registrationInfo.workingOrVolunteeringAsNP === "Yes" && (registrationInfo.npCompanyName === "" || registrationInfo.npCompanyName === null)) {
            console.log(stateKey + " failed validation");
            validation[input.npCompanyName] = { state: validationStrings.error, helpBlock: validationStrings.required };
          } 
        }

        if (stateKey === input.addressType && !registrationInfo.addressType) {
          console.log(stateKey + " failed validation");
          validation[input.addressType] = { state: validationStrings.error, helpBlock: validationStrings.required };
        }

        if(stateKey === input.country && !registrationInfo.country) {
          console.log(stateKey + " failed validation");
          validation[input.country] = { state: validationStrings.error, helpBlock: validationStrings.required };
        }

        if(stateKey === input.street1 && registrationInfo[input.street1] === "") {
          console.log(stateKey + " failed validation");
          validation[input.street1] = { state: validationStrings.error, helpBlock: validationStrings.required };
        }

        if(stateKey === input.city && registrationInfo[input.city] === "") {          
          console.log(stateKey + " failed validation");
          validation[input.city] = { state: validationStrings.error, helpBlock: validationStrings.required };          
        }

        if(stateKey === input.state && (this.state.internationalCountriesWithStates.includes(registrationInfo.country) && registrationInfo[input.state] === "")) {
          console.log(stateKey + " failed validation");
          validation[input.state] = { state: validationStrings.error, helpBlock: validationStrings.required };
        }

        if(stateKey === input.zip) {
          let country = this.state.internationalCountries.filter(obj => {
            return obj.countryName === this.ref_contactCountry.current.value
          })
          let result = this._isValidPostalCode(country[0].iso2, this.ref_contactPostalCode.current.value);
          if(result !== true) {
            console.log(stateKey + " failed validation: " + result);
            validation[input.zip] = { state: validationStrings.error, helpBlock: "" };              
            toast.error("Postal code " + (this.ref_contactPostalCode.current.value === "" ? "blank" : this.ref_contactPostalCode.current.value) + " is not valid for country " + this.ref_contactCountry.current.value + ".", {autoClose: 10000});
          }
        }
      }
    });

    this.setState({ validation });

    return !Object.keys(validation).length;

  };

  _proofOfStudiesUploaded = () => {
    console.log("_proofOfStudiesUploaded");
    this.setState({ studentApprovalUploaded: true });
  };

  render() {

    if (this.state.loading || this.state.loadingPrerequisites) {
      return <LoadingContent />;
    }

    console.log("render");    

    let { registrationInfo, validation, studentApprovalUploaded } = this.state;
    let { event } = this.props.me;
    let currentMembershipType = this.props.me.person.memberType.toLowerCase();
    let showRegistrationType = this.props.me.person.isMember && event.studentQuestions;
    let enableProofUpload = registrationInfo.isNp || registrationInfo.isPostGrad;

    return (
      <Page title="Conference Registration">
        <form>
          <Box title="Register Now!">
            <div className="row">
              <div className="col-lg-6">
                <div
                  className={
                    "inner-content mb-2 " +
                    (validation[input.npi] || validation[input.workingOrVolunteeringAsNP] ? validationStrings.error : "")
                  }
                >
                  <div className="mb-4">
                    {/* <div className="section-header">NPI Number (Required)</div>
                    <div className="question mb-3">
                      Please enter your personal NPI Number below:
                    </div> */}
                    <div className="section-header">NP Profile</div>
                  </div>
                  <div className="question">NPI Number:</div>
                  <div className="mb-1">
                    <input
                      type="text"
                      name="npi"
                      maxLength="10"
                      value={registrationInfo.npi ? registrationInfo.npi : ""}
                      className={validation[input.npi] ? validationStrings.error : ""}
                      onChange={this._handleChange}
                    />
                  </div>
                  <div className="mb-2">
                    <a
                      href="https://npiregistry.cms.hhs.gov/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Look up your NPI Number.
                    </a>
                  </div>
                  <div className="divider d-lg-none" />
                  <div className="mb-3">
                    <input
                      type="checkbox"
                      id="attest"
                      name="attest"
                      onChange={this._handleChange}
                    />
                    <label htmlFor="attest">
                      I attest I do not have an NPI Number.
                    </label>
                  </div>
                  <div className="divider" />
                  <div>
                    <div className="question">
                      Are you currently working or volunteering as an NP?
                    </div>
                    <select
                      value={registrationInfo.workingOrVolunteeringAsNP ? registrationInfo.workingOrVolunteeringAsNP : ""}
                      name="workingOrVolunteeringAsNP"
                      onChange={this._handleChange}
                      className={
                        validation[input.workingOrVolunteeringAsNP] ? validationStrings.error : ""
                      }
                    >
                      <option value="">Please select one of the following</option>
                      <option>Yes</option>
                      <option>No, I am a retired NP</option>
                      <option>No, I am a NP Student</option>
                      <option>No, I am an other APRN (CNS, CNM, CRNA)</option>
                      <option>No, other nurse</option>
                      <option>No, I am an NP but not currently working</option>
                      <option>No, I am not an NP or a nurse</option>
                    </select>
                  </div>
                  {registrationInfo.workingOrVolunteeringAsNP === "No, I am not an NP or a nurse" && (
                    <div>
                      <div className="divider" />
                      <div>
                        <div className="question">
                          Working as (please select one of the following):
                        </div>
                        <select
                          value={registrationInfo.nonNPJobProfession ? registrationInfo.nonNPJobProfession : ""}
                          name="nonNPJobProfession"
                          onChange={this._handleChange}
                        >
                          <option value="">
                            Please select one of the following
                          </option>
                          <option value="Physician">Physician</option>
                          <option value="Podiatrist">Podiatrist</option>
                          <option value="Optometrist">Optometrist</option>
                          <option value="Pharmacist">Pharmacist</option>
                          <option value="Chiropractor">Chiropractor</option>
                          <option value="Dentist">Dentist</option>
                          <option value="Physician Assistant">
                            Physician Assistant
                          </option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {registrationInfo.workingOrVolunteeringAsNP === "Yes" && (
                    <div>
                      <div className="divider" />
                      <div>
                        <div className="question">
                          Organization Name
                        </div>
                        <input
                          type="text"
                          name="npCompanyName"
                          //value = {this.state.npCompanyName}
                          value={registrationInfo.npCompanyName ? registrationInfo.npCompanyName : this.state.npCompanyName}
                          className={validation[input.npCompanyName] ? validationStrings.error : ""}
                          onChange={this._handleChange}
                          required={this.state.workingOrVolunteeringAsNP === "Yes" || registrationInfo.workingOrVolunteeringAsNP === "Yes"}
                        />

                      </div>
                      <div className="divider" />
                      <div>
                        <div className="question">
                          Are you currently working as an NP in the United States?
                        </div>
                        <select
                              value={registrationInfo.usNp ? registrationInfo.usNp : ""}                                                    
                              name="usNp"
                              onChange={this._handleChange}
                              className={validation[input.usNp] ? validationStrings.error : ""}
                            >
                              <option value="">Please select yes or no</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                          </select>
                      </div>
                      {registrationInfo.usNp === "Yes" && (
                      <div>
                        <div className="divider" />
                        <div>           
                          <div className="question">
                            What is your primary practice state?
                          </div>
                            <select
                              value={registrationInfo.primaryPracticeState ? registrationInfo.primaryPracticeState : ""}                                                    
                              name="primaryPracticeState"
                              onChange={this._handleChange}
                              className={validation[input.primaryPracticeState] ? validationStrings.error : ""}
                            >                
                              <option value="">Select a primary practice state</option>
                              {this.state.internationalStates.map((state, key) => (
                                <option 
                                  key={key} 
                                  value={state.stateAbbreviation}>{state.stateName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        )}
                      </div>
                    )}

                </div>
                <div className="divider d-lg-none" />
                <div
                  className={"inner-content mb-2 " + (validation[input.howDidYouHear] ? validationStrings.error : "")}
                >
                  <div className="section-header mb-3">
                    How Did You Hear About the Conference?
                  </div>
                  <select
                    value={ registrationInfo.howDidYouHear ? registrationInfo.howDidYouHear : "" }
                    name="howDidYouHear"
                    onChange={this._handleChange}
                    className={ validation[input.howDidYouHear] ? validationStrings.error : "" }
                  >                    
                    <option value="">Please select one of the following</option>
                    <option>AANP Website</option>
                    <option>AANP Mobile App</option>
                    <option>Facebook, X, Instagram, or other website</option>
                    <option>Email</option>
                    <option>Postcard</option>
                    <option>Advertisement (JNP, JAANP or other)</option>
                    <option>Friend/Colleague</option>
                  </select>
                </div>
                <div className="divider d-lg-none" />
                {event.conferenceType !== "Virtual" && 
                (this.state.applicationSettings["showCovidAttestation"] === "true") && (
                  <div 
                    className={"inner-content mb-2 " + (validation[input.ackCovidSafety] ? validationStrings.error : "")}
                  >
                  <div className="section-header">Safety Acknowledgment</div>
                  <div className="question mb-2">By registering, I agree to adhere to any AANP, Centers for Disease Control and Prevention and local guidelines or regulations related to any infectious disease, including COVID-19, in place at the time of the event.</div>                                                                                                                    
                  <div className="divider d-lg-none" />
                  <div className="mb-1">
                      <input
                        className={validation[input.ackCovidSafety] ? validationStrings.error : ""}
                        type="checkbox"
                        id="ackCovidSafety"
                        name="ackCovidSafety"                                                
                        onChange={this._handleChange}                                                                                            
                      />
                      <label htmlFor="ackCovidSafety">I acknowledge</label>
                  </div>
                </div>
                )}                    
              </div>              
              <div className="col-lg-6">
                <div className={"inner-content mb-2 " + (
                  validation[input.country] || 
                  validation[input.county] || 
                  validation[input.street1] || 
                  validation[input.city] || 
                  validation[input.zip] || 
                  validation[input.state] 
                    ? validationStrings.error : "")}
                >
                  <div className="divider d-lg-none" />
                  <div className="mb-4">
                    <div className="section-header">
                      Contact Address (Required)
                    </div>
                    <div className="question" style={{color: "#8d2d52"}}>Please note that the changes you make here will update the address we have on file for you.</div>
                    {registrationInfo.preferredMailingAddress === "" && (
                      <div className="question">
                        Please add a preferred address below:
                      </div>
                    )}
                  </div>
                  <div className="mb-2">
                    <label>Address Type</label>
                    <select
                      value={registrationInfo.addressType}
                      name="addressType"
                      onChange={this._handleChange}
                      className={ validation[input.addressType] ? validationStrings.error : "" }
                    >
                      <option value="">Please select one of the following</option>
                      <option>Home Address</option>
                      <option>Work Address</option>
                    </select>
                  </div>
                  <div className="mb-2">
                    <label>Country</label>
                    <select
                      ref={this.ref_contactCountry}              
                      value={registrationInfo.country ? registrationInfo.country : ""}
                      name="country"
                      autoComplete="address-country"
                      onChange={this._handleChange}
                      className={validation[input.country] ? validationStrings.error : ""}                        
                    >
                      <option value="">Please select one of the following</option>
                      {this.state.internationalCountries.map((country, key) => (
                        <option 
                          key={key} 
                          value={country.countryID}>{country.countryName}
                        </option>
                      ))}
                    </select>
                  </div>
                  {registrationInfo.addressType === "Work Address" && (
                    <div className="mb-2">
                      <label>Company Name (If Applicable)</label>
                      <input
                        type="text"
                        name="companyName"
                        autoComplete="organization"
                        //value={registrationInfo.companyName ? registrationInfo.companyName : ""}
                        value={this.state.companyName}
                        onChange={this._handleChange}
                      />
                    </div>
                  )}
                  <div className="mb-2">
                      <label>Address Line 1</label>
                      <input
                        type="text"
                        name="street1"
                        autoComplete="address-line1"
                        value={ registrationInfo.street1 ? registrationInfo.street1 : "" }
                        className={ validation[input.street1] ? validationStrings.error : "" }
                        onChange={this._handleChange}
                      />
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label>Address Line 2</label>
                      <input
                        type="text"
                        name="street2"
                        autoComplete="address-line1"
                        required
                        value={ registrationInfo.street2 ? registrationInfo.street2 : "" }                        
                        onChange={this._handleChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label>Address Line 3</label>
                      <input
                        type="text"
                        name="street3"
                        autoComplete="address-line3"                        
                        onChange={this._handleChange}
                      />
                    </div>
                  </div>
                  {this.state.showInternationalRegionTerritory &&
                    <div className="mb-2">
                      <label>Region / Territory</label>
                      <input
                        type="text"
                        name="county"
                        autoComplete="address-region"
                        value={ registrationInfo.county ? registrationInfo.county : "" }                        
                        onChange={this._handleChange}
                      />
                    </div>
                  }
                  <div className="row">                    
                    <div className="col-md-6">
                      <label>City</label>
                      <input
                        type="text"
                        name="city"
                        autoComplete="address-level2"
                        value={registrationInfo.city ? registrationInfo.city : ""}
                        className={validation[input.city] ? validationStrings.error : ""}
                        onChange={this._handleChange}
                      />
                    </div>  
                    {this.state.showState &&                    
                      <div className="col-md-3">           
                        <label>State</label>
                        <select
                          value={registrationInfo.state ? registrationInfo.state : ""}                                                    
                          name="state"
                          onChange={this._handleChange}
                          autoComplete="address-level1"
                          className={validation[input.state] ? validationStrings.error : ""}
                        >                
                          {this.state.internationalStates.map((state, key) => (
                            <option 
                              key={key} 
                              value={state.stateAbbreviation}>{state.stateName}
                            </option>
                          ))}
                        </select>
                      </div>
                    }
                    <div className="col-md-3">
                      <label>Postal Code</label>
                      <input
                        ref={this.ref_contactPostalCode}
                        type="text"
                        name="zip"
                        autoComplete="postal-code"
                        maxLength="10"
                        value={registrationInfo.zip ? registrationInfo.zip : ""}
                        className={validation[input.zip] ? validationStrings.error : ""}
                        onChange={this._handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className={"inner-content mb-2 " +
                    (validation[input.homePhone] || 
                    validation[input.businessPhone] || 
                    validation[input.cellPhone] 
                    ? validationStrings.error : "")}
                >
                  <div className="divider d-lg-none" />
                  <div className="mb-3">
                    <div className="section-header">
                      Phone Number (Required)
                    </div>
                    <div className="question">
                      Provide at least one phone number.
                    </div>
                    <div
                      className={ "phone-extension " + (validation[input.ext] ? validationStrings.error : "") }
                    >
                      If you include an extension, you must also include a valid Office phone number
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <label>Cell</label>                      
                      <PhoneInput                        
                        name="cellPhone"
                        ref={this.ref_contactMobilePhoneNumber}
                        inputProps={{ name: "contactMobilePhoneNumber", required: true }}                              
                        inputStyle={{ fontSize: ".8rem", fontFamily: "sans-serif", width: "100%" }}                        
                        disableAreaCodes
                        placeholder=""
                        country={"us"}                        
                        preferredCountries={["us","ca","au","gb"]}                                                
                        preserveOrder={["preferredCountries"]}
                        onlyCountries={this.state.internationalCountryCodes}
                        className={validation[input.cellPhone] ? validationStrings.error : ""} 
                        value={registrationInfo.cellPhone}
                        onChange={this._onPhoneNumberChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label>Home</label>
                      <PhoneInput
                        name="homePhone"
                        ref={this.ref_contactHomePhoneNumber}
                        inputProps={{ name: "contactHomePhoneNumber", required: true }}                              
                        inputStyle={{ fontSize: ".8rem", fontFamily: "sans-serif", width: "100%" }}                        
                        disableAreaCodes
                        placeholder=""
                        country={"us"}
                        preferredCountries={["us","ca","au","gb"]}
                        preserveOrder={["preferredCountries"]}                        
                        onlyCountries={this.state.internationalCountryCodes}
                        className={validation[input.homePhone] ? validationStrings.error : ""} 
                        value={registrationInfo.homePhone}
                        onChange={this._onPhoneNumberChange}
                        />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <label>Work</label>
                      <PhoneInput
                        name="businessPhone"
                        ref={this.ref_contactOfficePhoneNumber}
                        inputProps={{ name: "contactOfficePhoneNumber", required: true }}                              
                        inputStyle={{ fontSize: ".8rem", fontFamily: "sans-serif", width: "100%" }}                        
                        disableAreaCodes
                        placeholder=""
                        country={"us"}
                        preferredCountries={["us","ca","au","gb"]}
                        onlyCountries={this.state.internationalCountryCodes}
                        className={validation[input.businessPhone] ? validationStrings.error : ""} 
                        value={registrationInfo.businessPhone}
                        onChange={this._onPhoneNumberChange}
                        />
                    </div>
                    <div className="col-md-4">
                      <label>Ext.</label>
                      <input
                        type="text"
                        name="ext"
                        autoComplete="tel-extension tel"
                        value={registrationInfo.ext ? registrationInfo.ext : ""}
                        onChange={this._handleChange}
                      />
                    </div>
                  </div>
                </div>                
{/*                 {config.showEmergencyContactSection &&
                  <div className={"inner-content mb-2 " + (
                    validation[input.emergencyContactFirstName] || 
                      validation[input.emergencyContactLastName] ||
                      validation[input.emergencyContactEmail] ||
                      validation[input.emergencyContactPhoneNumber] 
                      ? validationStrings.error : "")}
                  >
                    <div className="divider d-lg-none" />
                    <div className="mb-3">
                      <div className="section-header">
                        Emergency Contact (Required)
                      </div>
                      <div className="question">
                        AANP is authorized to use and may utilize at their discretion my emergency contact information in the event of a medical emergency.
                      </div>    
                      <div className="row">
                        <div className="col-md-6">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="emergencyContactFirstName"
                            maxLength="50"
                            required
                            value={registrationInfo.emergencyContactFirstName ? registrationInfo.emergencyContactFirstName : "" }
                            className={validation[input.emergencyContactFirstName] ? validationStrings.error : ""}                                                                                                                                
                            onChange={this._handleChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label>Last Name</label>
                          <input
                            type="text"
                            name="emergencyContactLastName"
                            maxLength="50"
                            required
                            value={registrationInfo.emergencyContactLastName ? registrationInfo.emergencyContactLastName : ""}
                            className={validation[input.emergencyContactLastName] ? validationStrings.error : ""}  
                            onChange={this._handleChange}
                          />                                            
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col">
                          <label>Email</label>
                          <input
                            type="text"
                            name="emergencyContactEmail"
                            maxLength="100"                                                                                                                                        
                            value={registrationInfo.emergencyContactEmail ? registrationInfo.emergencyContactEmail : ""}
                            className={validation[input.emergencyContactEmail] ? validationStrings.error : ""}
                            onChange={this._handleChange}
                          />
                        </div>
                      </div>                     
                      <div className="row mb-2">
                        <div className="col-md-6">
                          <label>Relationship (Optional)</label>
                          <input 
                            type="text"
                            name="emergencyContactRelationship"
                            maxLength="50"
                            value={registrationInfo.emergencyContactRelationship ? registrationInfo.emergencyContactRelationship : ""}                                                       
                            onChange={this._handleChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label>Cell Phone Number</label>
                          <PhoneInput
                            ref={this.ref_emergencyContactPhoneNumber}
                            inputProps={{ name: "emergencyContactPhoneNumber", required: true }}                              
                            inputStyle={{ fontSize: ".8rem", fontFamily: "sans-serif", width: "100%" }}                          
                            disableAreaCodes
                            placeholder=""
                            country={"us"}
                            preferredCountries={["us","ca","au","gb"]}
                            onlyCountries={this.state.internationalCountryCodes}
                            className={validation[input.emergencyContactPhoneNumber] ? validationStrings.error : ""} 
                            value={registrationInfo.emergencyContactPhoneNumber}
                            onChange={this._onPhoneNumberChange}
                          />
                        </div>
                      </div>
                    </div>                                                   
                </div>  
              } */}
            </div>
          </div>
          <div className="row"style={{marginLeft: "4px", marginRight: "1px"}}>
              {config.showEmergencyContactSection &&
                <div className={"inner-content mb-2 " + (
                    validation[input.emergencyContactFirstName] || 
                      validation[input.emergencyContactLastName] ||
                      validation[input.emergencyContactEmail] ||
                      validation[input.emergencyContactPhoneNumber] 
                      ? validationStrings.error : "")}
                  >
                    <div className="divider d-lg-none" />
                    <div className="mb-3">
                      <div className="section-header">
                        Emergency Contact (Required)
                      </div>
                      <div className="question">
                        AANP is authorized to use and may utilize at their discretion my emergency contact information in the event of a medical emergency.
                      </div>    
                      <div className="row">
                        <div className="col-md-6">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="emergencyContactFirstName"
                            maxLength="50"
                            required
                            value={registrationInfo.emergencyContactFirstName ? registrationInfo.emergencyContactFirstName : "" }
                            className={validation[input.emergencyContactFirstName] ? validationStrings.error : ""}                                                                                                                                
                            onChange={this._handleChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label>Last Name</label>
                          <input
                            type="text"
                            name="emergencyContactLastName"
                            maxLength="50"
                            required
                            value={registrationInfo.emergencyContactLastName ? registrationInfo.emergencyContactLastName : ""}
                            className={validation[input.emergencyContactLastName] ? validationStrings.error : ""}  
                            onChange={this._handleChange}
                          />                                            
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col">
                          <label>Email</label>
                          <input
                            type="text"
                            name="emergencyContactEmail"
                            maxLength="100"                                                                                                                                        
                            value={registrationInfo.emergencyContactEmail ? registrationInfo.emergencyContactEmail : ""}
                            className={validation[input.emergencyContactEmail] ? validationStrings.error : ""}
                            onChange={this._handleChange}
                          />
                        </div>
                      </div>                     
                      <div className="row mb-2">
                        <div className="col-md-6">
                          <label>Relationship (Optional)</label>
                          <input 
                            type="text"
                            name="emergencyContactRelationship"
                            maxLength="50"
                            value={registrationInfo.emergencyContactRelationship ? registrationInfo.emergencyContactRelationship : ""}                                                       
                            onChange={this._handleChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label>Cell Phone Number</label>
                          <PhoneInput
                            ref={this.ref_emergencyContactPhoneNumber}
                            inputProps={{ name: "emergencyContactPhoneNumber", required: true }}                              
                            inputStyle={{ fontSize: ".8rem", fontFamily: "sans-serif", width: "100%" }}                          
                            disableAreaCodes
                            placeholder=""
                            country={"us"}
                            preferredCountries={["us","ca","au","gb"]}
                            onlyCountries={this.state.internationalCountryCodes}
                            className={validation[input.emergencyContactPhoneNumber] ? validationStrings.error : ""} 
                            value={registrationInfo.emergencyContactPhoneNumber}
                            onChange={this._onPhoneNumberChange}
                          />
                        </div>
                      </div>
                    </div>                                                   
                </div>  
              }
          </div>
            {showRegistrationType && (
              <div className="row">
                <div className="col-lg-6">
                  <div className="divider d-lg-none" />
                  <div className="registration-type">
                    <div className="section-header mb-3 d-none">
                      Registration Type: {registrationInfo.registeringAs}
                    </div>
                    {currentMembershipType.includes("np") && (
                      <React.Fragment>
                        <div className="checkbox-container">
                          <label
                            className="question"
                            htmlFor="graduate-studies"
                          >
                            I am enrolled in post-graduate studies
                          </label>
                          <input
                            type="checkbox"
                            name="isPostGrad"
                            id="graduate-studies"
                            checked={!!registrationInfo.isPostGrad}
                            onChange={this._handleChange}
                          />
                        </div>
                        <div className="checkbox-container">
                          <label className="question" htmlFor="recently">
                            I have recently retired
                          </label>
                          <input
                            type="checkbox"
                            name="isRetired"
                            id="recently"
                            checked={!!registrationInfo.isRetired}
                            onChange={this._handleChange}
                          />
                        </div>
                      </React.Fragment>
                    )}
                    {currentMembershipType.includes("post") && (
                      <div className="checkbox-container">
                        <label className="question" htmlFor="graduate-studies">
                          I am enrolled in post-graduate studies
                        </label>
                        <input
                          type="checkbox"
                          name="isPostGrad"
                          id="graduate-studies"
                          checked={!!registrationInfo.isPostGrad}
                          onChange={this._handleChange}
                        />
                      </div>
                    )}
                    {currentMembershipType.includes("student") &&
                      !currentMembershipType.includes("post") && (
                        <React.Fragment>
                          <div className="checkbox-container">
                            <label className="question" htmlFor="enrolled">
                              I am enrolled in an NP program at this time
                            </label>
                            <input
                              type="checkbox"
                              id="enrolled"
                              name="isNp"
                              checked={registrationInfo.isNp}
                              onChange={this._handleChange}
                            />
                          </div>
                        </React.Fragment>
                      )}
                    {currentMembershipType.includes("student") &&
                      !currentMembershipType.includes("post") && (
                        <div className="checkbox-container">
                          <label className="question" htmlFor="graduated">
                            I have graduated in the last 12 months
                          </label>
                          <input
                            type="checkbox"
                            name="isGraduated"
                            id="graduated"
                            checked={!!registrationInfo.isGraduated}
                            onChange={this._handleChange}
                          />
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="mt-1 pb-4 d-none d-lg-block" />
                  {!studentApprovalUploaded && enableProofUpload && (
                    <ProofOfStudiesUpload
                      onUploaded={this._proofOfStudiesUploaded}
                      enabled={enableProofUpload}
                    />
                  )}
                </div>
              </div>
            )}
          </Box>

          {event.quickCheckout && event.sessionSelection && (
            <div>

              {/* 
              - What's Next = True
              - Session frame = True
              - Quick frame = True
              - TOS Under both frames = True
              - Button under TOS = False
              */}

              <Box title="Next Steps">
                <div className="row checkout" >

                  {/* TOS */}
                  <div className="row" style={{marginLeft: "1px", marginRight: "1px", marginBottom: "25px"}}>
                    <div className="col-lg-12 col-centered">
                      <div className="tos-box p-4">
                        By continuing the registration process, I agree to abide by the AANP Conference{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.conferenceTermsOfService}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Service and Release of Liability.
                        </a>{" "}
                        I additionally agree to abide by AANP’s{" "}
                          <a style={{ fontWeight: "bold" }}
                          href={strings.aanpTermsOfUse}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Use
                        </a>{" "}
                        and{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.aanpPrivacyPolicy}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* Quick Checkout Frame */}                
                  <div className="col-lg">
                    <div className="inner-content mb-2">
                      <div className="txt-sm-bold">Quick Checkout</div>
                      <p>
                        Short on time? No problem! Pay now and come back to
                        select your sessions anytime with the Quick Checkout
                        option.
                      </p>                      
                        <LoadingButton
                          text="Agree and Checkout"
                          loadingText="Saving..."
                          isLoading={this.state.isLoadingQuickCheckout}
                          onClick={this._saveRegistrationInfo}
                          value="checkout"
                        />                
                    </div>
                  </div>                 

                  {/* Session Frame */}
                  <div className="col-lg">
                      <div className="inner-content mb-2">
                        <div className="txt-sm-bold">Session Selection</div>
                        <p>
                          Have a few minutes? Select your sessions now and pay
                          afterward.
                        </p>                        
                          <LoadingButton
                            text="Agree and Select Sessions"
                            loadingText="Saving..."
                            isLoading={this.state.isLoadingCheckout}
                            onClick={this._saveRegistrationInfo}
                            value="sessions"
                          />                       
                      </div>
                    </div>
                </div>
              </Box>
            </div>
          )}

          {event.quickCheckout && !event.sessionSelection && (
            <div>

              {/* 
              - What's Next = False
              - Session frame = False
              - Quick frame = False
              - TOS = True
              - Button under TOS = True
              */}

              <div className="row checkout">  

                  {/* TOS */}
                  <div className="row mt-3">
                    <div className="col-lg-11 col-centered">
                      <div className="tos-box p-4">
                        By continuing the registration process, I agree to abide by the AANP Conference{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.conferenceTermsOfService}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Service and Release of Liability.
                        </a>{" "}
                        I additionally agree to abide by AANP’s{" "}
                          <a style={{ fontWeight: "bold" }}
                          href={strings.aanpTermsOfUse}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Use
                        </a>{" "}
                        and{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.aanpPrivacyPolicy}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </div>

                      {/* Button */}
                      <div className="row mt-3">
                      <div className="col-10 col-lg-5 col-centered">
                          <LoadingButton
                              text="Agree and Checkout"
                              loadingText="Saving..."
                              isLoading={this.state.isLoadingQuickCheckout}
                              onClick={this._saveRegistrationInfo}
                              value="checkout"
                            />
                          </div>
                      </div>

                    </div>

                  </div>

              </div>

            </div>
          )}

          {!event.quickCheckout && event.sessionSelection && (
            <div>

              {/* 
              - What's Next = False
              - Session frame = False
              - Quick frame = False
              - TOS  = True
              - Button under TOS = True
              */}

              <div className="row checkout">  

                  {/* TOS */}
                  <div className="row mt-3">
                    <div className="col-lg-11 col-centered">
                      <div className="tos-box p-4">
                        By continuing the registration process, I agree to abide by the AANP Conference{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.conferenceTermsOfService}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Service and Release of Liability.
                        </a>{" "}
                        I additionally agree to abide by AANP’s{" "}
                          <a style={{ fontWeight: "bold" }}
                          href={strings.aanpTermsOfUse}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Use
                        </a>{" "}
                        and{" "}
                        <a style={{ fontWeight: "bold" }}
                          href={strings.aanpPrivacyPolicy}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy
                        </a>
                      </div>

                      {/* Button */}
                      <div className="row mt-3">
                        <div className="col-10 col-lg-5 col-centered">
                          <LoadingButton
                              text="Agree and Select Sessions"
                              loadingText="Saving..."
                              isLoading={this.state.isLoadingCheckout}
                              onClick={this._saveRegistrationInfo}
                              value="sessions"
                            />
                          </div>
                      </div>

                    </div>

                  </div>

              </div>

            </div>
          )}

          {!event.quickCheckout && !event.sessionSelection && (
            <div>

              {/* 
              - What's Next = False
              - Session frame = False
              - Quick frame = False
              - TOS  = False
              - Button under TOS = False
              */}

              {/* Intentionally Left Blank */}

            </div>
          )}

        </form>
        {event.sessionSelection && (
            <footer className="mb-1 mt-3 ml-3 mr-3">
            <div className="txt-sm-bold">
              Are You Interested in Learning More Before Registering?
            </div>
            <div className="footer-text">
              View the{" "}
              {event.conferenceType === "Fall" && (
              <a href={fallConferenceSessionsUrl} target="_blank" rel="noopener noreferrer">Session Detail Listing</a>
              )}
              {event.conferenceType === "National" && (
              <a href={nationalConferenceSessionsUrl} target="_blank" rel="noopener noreferrer">Session Detail Listing</a>
              )}        
              {/* Fall through */}
              {event.conferenceType !== "Fall" && event.conferenceType !== "National" && (
              <a href="https://sessions.aanp.org" target="_blank" rel="noopener noreferrer">Session Detail Listing</a>
              )}
              {" "}for more information on what will be offered during this conference.
            </div>
          </footer>
        )}
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    me: state.account.me,
    registrationMembershipType: state.membership.registrationMembershipType,
  };
};

const mapDispatchToProps = {
  ...membershipActions,
  ...registrationActions,
  ...accountActions,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DefaultConferenceQuestions)
);